/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React, { FC, ReactNode, useRef, useState } from 'react';
import cn from 'classnames';
import Portal from 'components/Portal';
import css from './styles.module.scss';
import { useTooltipPoratal } from './hooks/useTooltipPoratal';

export interface ITooltipPoratalProps {
  /** Доплнительный класс для основного тела */
  classname?: string;
  /** Дополнительный класс для подсказки, когда она вне DOM */
  hintClassName?: string;
  /** Основной элемент для наведения */
  children: ReactNode;
  /** Всплывающая подсказка */
  hint: ReactNode | string;
  /** Скрыть подсказку по условию */
  hideHint?: boolean;
  /** Белая подсказка */
  white?: boolean;
  /** Ширина подсказки */
  hintWidth?: number;
  onClick?: ((e?: React.MouseEvent) => void) | undefined;
  /* Показывать постоянно на странице */
  showConstantly?: boolean;
  /** Отображение слева от иконки */
  left?: boolean;
  /** Отображение справа от иконки */
  right?: boolean;
  /** Отображение снизу от иконки */
  bottom?: boolean;
  /** Отображение снизу по правому краю тела */
  bottomRight?: boolean;
  /** Состояние disable */
  isDisabled?: boolean;
  /** Начало подсказки в начале блока */
  leftArrowPosition?: boolean;
  /** ref на основной элемент */
  ref?: any;
}

/** Tooltip вне DOM дерева. С выходом за рамки ограничений видимости */
const TooltipPoratal: FC<ITooltipPoratalProps> = ({
  classname,
  hintClassName,
  children,
  hint,
  white,
  hideHint = false,
  hintWidth,
  showConstantly = false,
  onClick,
  left,
  right,
  bottom,
  bottomRight,
  isDisabled,
  leftArrowPosition,
  ref,
}) => {
  const hintRef = useRef<HTMLDivElement | null>(null);
  const mainRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { positionLeft, positionTop, placementResult, bodyOutsideView } = useTooltipPoratal({
    _isOpen: isOpen,
    hintRef,
    mainRef,
    showFirst: showConstantly,
    left,
    right,
    bottom,
    bottomRight,
  });

  return (
    <div
      ref={mainRef}
      className={cn(css.tooltipPoratal, 'TooltipPoratal', classname, {
        isDisabled,
      })}
      onClick={onClick}
    >
      <div
        className={cn(css.body, 'TooltipPoratal_body')}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        ref={ref}
      >
        {children}
      </div>
      {(isOpen || showConstantly) && !hideHint && !bodyOutsideView && (
        <Portal className="TooltipPoratal">
          <div
            ref={hintRef}
            className={cn(css.hint, 'TooltipPoratal_hint', hintClassName, {
              _isOpen: isOpen || showConstantly,
              _isWhite: white,
              _isLeft: placementResult === 'left',
              _isRight: placementResult === 'right',
              _isBottom: placementResult === 'bottom',
              _isBottomRight: placementResult === 'bottomRight',
              _isLeftArrow: leftArrowPosition,
            })}
            style={{
              left: `${positionLeft}px`,
              top: `${positionTop}px`,
              maxWidth: `${hintWidth}px`,
            }}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
          >
            {hint}
          </div>
        </Portal>
      )}
    </div>
  );
};

export default TooltipPoratal;